<template>
  <div style="background: #eeeeee;" class="Agenda pa-1">
    <v-card>
      <h3 class="white--text text--lighten-4 blue-grey darken-3">
        <v-card-title class="title">
          <v-icon large color="orange lighten-4" class>mdi-book-account</v-icon>Agenda
        </v-card-title>
      </h3>

      <v-spacer></v-spacer>
      <v-row class="pl-5 pb-5">
        <v-col>
          <h4 class="orange--text title px-auto">Contatos</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-text-field
            v-model="dataSearch"
            prepend-icon="mdi-comment-search-outline"
            :clearable="true"
            dense
            label="Procurar Contato"
            single-line
            hide-details
          >></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-btn
            align="middle"
            small
            color="orange lighten-4"
            class="mb-2 mx-12"
            @click="addContato()"
          >Adicionar Contato</v-btn>
        </v-col>
      </v-row>
      <v-data-table class="caption" :headers="headersDataCol" :items="dataCol" :search="dataSearch">
        <template v-slot:[`item.telefone`]="{ item }">
          <span v-html="telefoneFormat(item.telefone)"></span>
        </template>
        <template v-slot:[`item.celular`]="{ item }">
          <span v-html="telefoneFormat(item.celular)"></span>
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <v-icon class="mr-2" small color="blue" @click="editarContato(item)">mdi-pencil</v-icon>
          <v-icon small @click="removerContato(item,true)" color="red">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="editDialog" scrollable min-width="50%" max-width="800px">
      <v-card height="600px">
        <v-alert type="info" class="text-center" dense>
          <strong>MODIFICANDO CONTATO</strong>
        </v-alert>
        <p class="body-2 text-center ma-4">
          Modificando os dados de
          <strong>{{col.nome}}</strong>
        </p>
        <v-divider></v-divider>
        <vuescroll ref="vs" :ops="ops">
          <v-form class="mt-1 mx-3" v-model="valid" @submit.prevent>
            <v-text-field
              :outlined="true"
              label="Nome Completo"
              hint="Exemplo: Victor Barbieri"
              prepend-icon="mdi-account"
              required
              autofocus
              dense
              :rules="nomeRules"
              v-model="nome"
            ></v-text-field>

            <v-text-field
              :outlined="true"
              label="Telefone Fixo"
              value
              prepend-icon="mdi-phone"
              dense
              v-model="telefone"
              hint="Insira somente numeros"
              :rules="telefoneRules"
            ></v-text-field>
            <v-text-field
              :outlined="true"
              label="Telefone Celular / WhatsApp"
              value
              prepend-icon="mdi-cellphone"
              dense
              v-model="celular"
              :rules="celularRules"
              hint="Insira somente numeros sem o numero 9 adicional"
            ></v-text-field>
            <v-text-field
              :outlined="true"
              label="E-mail"
              prepend-icon="mdi-card-account-mail"
              :rules="emailRules"
              v-model="email"
              dense
            ></v-text-field>
            <v-textarea
              dense
              prepend-icon="mdi-comment"
              clearable
              :outlined="true"
              rows="4"
              v-model="complementares"
              label="Informações Complementares"
              value
            ></v-textarea>
          </v-form>
        </vuescroll>
        <v-divider></v-divider>
        <p class="text-center">
          <v-btn
            color="green darken-1"
            text
            :disabled="!valid"
            :loading="loading"
            @click="(loader = 'loading');
              editDialog = false
              editarContatoBD();
            "
          >MODIFICAR</v-btn>
          <v-btn color="red darken-1" text @click="editDialog = false">CANCELAR EDIÇÃO</v-btn>
        </p>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addDialog" scrollable min-width="50%" max-width="800px">
      <v-card height="600px">
        <v-alert type="info" class="text-center" dense>
          <strong>ADICIONANDO CONTATO</strong>
        </v-alert>
        <v-form class="mt-1 mx-3" v-model="valid" @submit.prevent>
          <v-text-field
            :outlined="true"
            label="Nome Completo"
            hint="Exemplo: Victor Barbieri"
            prepend-icon="mdi-account"
            required
            autofocus
            dense
            :rules="nomeRules"
            v-model="nome"
          ></v-text-field>

          <v-text-field
            :outlined="true"
            label="Telefone Fixo"
            value
            prepend-icon="mdi-phone"
            dense
            v-model="telefone"
            hint="Insira somente numeros"
            :rules="telefoneRules"
          ></v-text-field>
          <v-text-field
            :outlined="true"
            label="Telefone Celular"
            value
            prepend-icon="mdi-cellphone"
            dense
            v-model="celular"
            :rules="celularRules"
            hint="Insira somente numeros sem o numero 9 adicional"
          ></v-text-field>
          <v-text-field
            :outlined="true"
            label="E-mail"
            prepend-icon="mdi-card-account-mail"
            :rules="emailRules"
            v-model="email"
            dense
          ></v-text-field>
          <v-textarea
            dense
            prepend-icon="mdi-comment"
            clearable
            :outlined="true"
            rows="4"
            v-model="complementares"
            label="Informações Complementares"
            value
          ></v-textarea>
        </v-form>
        <v-divider></v-divider>
        <p class="text-center">
          <v-btn
            color="green darken-1"
            text
            :disabled="!valid"
            :loading="loading"
            @click="(loader = 'loading');
              addDialog = false
              addContatoDB();
            "
          >ADICIONAR CONTATO</v-btn>
          <v-btn color="red darken-1" text @click="addDialog = false">CANCELAR ADIÇÃO</v-btn>
        </p>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogResposta" min-width="20%" max-width="450px">
      <v-card>
        <v-col v-if="message == 'error'">
          <v-alert type="error" class="text-center" dense>
            Tivemos um problema.
            <strong>Agenda</strong> não alterada
          </v-alert>
          <p class="caption text-center">
            Por favor contate o setor de T.I.
            <br />
            <strong>E-mail:</strong> ti@contabilidadelider.com
          </p>
          <code v-text="respostaErro"></code>
        </v-col>
        <v-col v-else-if="message == 'success'">
          <v-alert type="success" class="text-center" dense>
            <strong>Agenda</strong> atualizada com sucesso.
          </v-alert>
        </v-col>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogRemoverContato" max-width="400">
      <v-card>
        <v-alert type="info" class="text-center" dense>
          <strong>REMOVER CONTATO</strong>
        </v-alert>
        <p class="body-2 text-center">
          Você gostaria de
          <strong>REMOVER</strong> o contato:
          <br />
          <br />
          <strong>{{col.nome}}</strong>
          ?
          <br />
          <br />
          <strong>Está ação não poderá ser desfeita.</strong>
          <v-btn
            color="green darken-1"
            text
            @click="
            removerContato(null,false);
              dialogRemoverContato = false;
            "
          >REMOVER CONTATO</v-btn>
          <v-btn color="red darken-1" text @click="dialogRemoverContato = false">NÃO REMOVER</v-btn>
        </p>
        <br />
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import vuescroll from "vuescroll/dist/vuescroll-native";
export default {
  name: "Agenda",
  components: { vuescroll },
  data() {
    return {
      //formulario
      show1: false,
      loading: false,
      loader: null,
      valid: true,
      nome: "",
      telefone: "",
      celular: "",
      email: "",
      complementares: "",

      dialogRemoverContato: false,
      message: "",
      respostaErro: "",

      dialogResposta: false,

      nomeRules: [
        (value) => !!value || "Informe o nome Completo",
        (value) =>
          /^$|^.{0,40}$/.test(value) ||
          "O nome deve ter no máximo 40 caracteres",
      ],
      telefoneRules: [
        (value) =>
          /^$|^\d+$/.test(value) || "O telefone deve conter somente numeros",
        (value) =>
          /^$|^.{10,10}$/.test(value) ||
          "O telefone deve conter no máximo 10 numeros",
      ],
      celularRules: [
        (value) =>
          /^$|^\d+$/.test(value) || "O celular deve conter somente numeros",
        (value) =>
          /^$|^.{10,10}$/.test(value) ||
          "O telefone deve conter 10 numeros. Sem o 9.",
      ],
      emailRules: [
        (value) =>
          /^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            value
          ) || "E-mail com formato invalido. Use email@mail.com",
        (value) =>
          /^$|^.{0,35}$/.test(value) ||
          "O E-mail deve ter no máximo 35 caracteres",
      ],

      //end
      dataSearch: "",
      editDialog: false,
      addDialog: false,
      removeDialog: false,
      col: "",
      dataCol: [],
      headersDataCol: [
        { text: "Nome", value: "nome" },
        { text: "Telefone", value: "telefone" },
        { text: "Celular", value: "celular" },
        { text: "E-mail", value: "email" },
        { text: "Informações Comp.", value: "complementares" },
        { text: "Ações", value: "acoes", sortable: false, align: "end" },
      ],
      ops: {
        vuescroll: {
          detectResize: false,
        },
        bar: {
          showDelay: 500,
          onlyShowBarOnScroll: true,
          keepShow: true,
          background: "#37474F",
          opacity: 0.5,
          hoverStyle: false,
          specifyBorderRadius: false,
          minSize: 0,
          size: "6px",
          disable: false,
        },
      },
    };
  },

  methods: {
    addContato() {
      (this.nome = ""),
        (this.telefone = ""),
        (this.celular = ""),
        (this.email = ""),
        (this.complementares = ""),
        (this.addDialog = true);

      setTimeout(() => {
        this.scrollToElement();
      }, 10);
    },
    editarContato(col) {
      this.col = col;
      (this.nome = ""),
        (this.telefone = ""),
        (this.celular = ""),
        (this.email = ""),
        (this.complementares = ""),
        (this.editDialog = true);
      setTimeout(() => {
        this.scrollToElement();
      }, 10);
      typeof col.nome !== "undefined"
        ? (this.nome = col.nome)
        : (this.nome = "");
      typeof col.telefone !== "undefined"
        ? (this.telefone = col.telefone)
        : (this.telefone = "");
      typeof col.celular !== "undefined"
        ? (this.celular = col.celular)
        : (this.celular = "");
      typeof col.email !== "undefined"
        ? (this.email = col.email)
        : (this.email = "");
      typeof col.complementares !== "undefined"
        ? (this.complementares = col.complementares)
        : (this.complementares = "");
    },

    removerContato(col, dialog) {
      if (dialog) {
        this.col = col;
        this.dialogRemoverContato = true;
      } else {
        this.payload = {
          id: this.col._id,
        };
        this.$store.dispatch("removerContato", this.payload).then(
          (result) => {
            this.dataCol = result;
            this.dialogResposta = true;
            this.message = "success";
          },
          (error) => {
            this.dialogResposta = true;
            this.loading = false;
            this.respostaErro = error;
            this.message = "error";
          }
        );
      }
    },
    addContatoDB() {
      this.payload = {
        id: this.col._id,
        nome: this.nome,
        telefone: this.telefone,
        celular: this.celular,
        email: this.email,
        complementares: this.complementares,
      };
      this.$store.dispatch("addContato", this.payload).then(
        (result) => {
          this.dataCol = result;
          this.dialogResposta = true;
          this.message = "success";
        },
        (error) => {
          this.dialogResposta = true;
          this.loading = false;
          this.respostaErro = error;
          this.message = "error";
        }
      );
    },
    editarContatoBD() {
      this.payload = {
        id: this.col._id,
        nome: this.nome,
        telefone: this.telefone,
        celular: this.celular,
        email: this.email,
        complementares: this.complementares,
      };
      this.$store.dispatch("editarContato", this.payload).then(
        (result) => {
          this.dataCol = result;
          this.dialogResposta = true;
          this.message = "success";
        },
        (error) => {
          this.dialogResposta = true;
          this.loading = false;
          this.respostaErro = error;
          this.message = "error";
        }
      );
    },
    scrollToElement() {
      if (typeof this.$refs["vs"] !== "undefined") {
        this.$refs["vs"].scrollBy(
          {
            dy: -4000,
          },
          0
        );
      }
    },
    telefoneFormat(telefone) {
      if (typeof telefone === "undefined") {
        telefone = "";
      }
      if (telefone.length === 10) {
        return (
          "(" +
          telefone.substring(0, 2) +
          ") " +
          telefone.substring(2, 6) +
          "-" +
          telefone.substring(6)
        );
      } else if (telefone.length === 8) {
        return telefone.substring(0, 4) + "-" + telefone.substring(4);
      } else if (telefone.length === 11) {
        return (
          "(" +
          telefone.substring(0, 2) +
          ") " +
          telefone.substring(2, 7) +
          "-" +
          telefone.substring(7)
        );
      } else if (telefone.length < 4) {
        return "";
      } else return telefone;
    },
  },
  mounted() {
    this.$store.dispatch("listarContato").then(
      (contatos) => {
        this.dataCol = contatos;
      },
      () => {
        this.$router.push("/");
      }
    );
  },
};
</script>